import * as React from 'react';
import { getBackendBaseUrl } from '../../infrastructure/BackendUrlResolver';
import withImportantSupport from '../../infrastructure/WithImportantComponent';

export interface ImageFromBlobProps {
    id?: string;
    alt?: string;
}

export function ImageFromBlob(props: ImageFromBlobProps) {
    // https://stackoverflow.com/questions/31226314/react-adding-important-seems-to-break-component-re-rendering
    const DivWithImportant = withImportantSupport('div');

    let className = 'card-image';

    let imageUrl = require('../../content/img/placeholder.png');
    if (props.id !== undefined && props.id !== null) {
        imageUrl = `${getBackendBaseUrl()}/api/image/${props.id}`;
    } else {
        className += ' no-image';
    }

    return <DivWithImportant className={className} style={{ backgroundImage: `url('${imageUrl}')!important` }}/>;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/ImageFromBlob.tsx